import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=bb53621a&scoped=true&"
import script from "./orderRefund.vue?vue&type=script&lang=js&"
export * from "./orderRefund.vue?vue&type=script&lang=js&"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=bb53621a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb53621a",
  null
  
)

export default component.exports